module.exports = __webpack_public_path__ + "img/menu-active.2e270d7a.svg";